import GlobalMenu from './GlobalMenu'
import GlobalMenuMobile from './GlobalMenuMobile'

GlobalMenu.Mobile= GlobalMenuMobile
export default GlobalMenu
